import React from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import Button from '@cloudscape-design/components/button';
import SpaceBetween from '@cloudscape-design/components/space-between';
import PaymentLookup from './PaymentLookup';
import { useAppContext } from './App';

const PaymentPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { token, apiBase } = useAppContext();
  const initialId = searchParams.get('q') || '';

  return (
    <SpaceBetween size="l">
      <Button iconName="arrow-left" variant="link" onClick={() => navigate('/')}>Back to Home</Button>
      <PaymentLookup token={token} initialId={initialId} apiBase={apiBase} />
    </SpaceBetween>
  );
};

export default PaymentPage;
